import { useState } from 'react';
import 'styles/quotetext.css';
import { useEffect } from 'react';

const QuoteText = (
    {
        variable,
        setVariable,
        label,
        onChange = () => {}
    }
) => {

    const [text,setText]=useState("");

    useEffect(()=>{
        setText(variable)
    },[variable]);

    const handleChange = (event) => {
        setText(event.target.value);
    };

    const onBlur = (event) => {
        setVariable(event.target.value);
        onChange(event.target.value);
    };

    const handleKey = (event) => {
        if (event.key === 'Enter' || event.key === 'Escape') event.target.blur();
    };

    return (
        <div
            className='QuoteText'
        >
            <input
                type="text"
                value={text}
                onChange={handleChange}
                placeholder={label}
                onBlur={onBlur}
                onKeyDown={handleKey}
            />
        </div>
    );
};

export default QuoteText;